module.exports = __webpack_public_path__ + "media/images/gallery/constellations/scutum/sct_vis-f27cb41b4f0d26a5eb2de02cb2b94c48.jpg";